import type * as React from 'react';

export const CustomCloudSavedIcon = ({
    size = 24,
    color = 'currentColor',
    strokeWidth = 1.33,
    className,
    ...props
}: React.SVGProps<SVGSVGElement> & {
    size?: number;
    color?: string;
    strokeWidth?: number;
}) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M11.3333 10L7.66667 13.6667L6 12"
                stroke={color}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3.33335 11.8287C2.72195 11.4027 2.22145 10.8365 1.87372 10.1774C1.52599 9.51833 1.34115 8.78557 1.33465 8.04042C1.32815 7.29528 1.50019 6.55941 1.83638 5.89438C2.17256 5.22935 2.66311 4.6545 3.26699 4.21791C3.87088 3.78132 4.57053 3.49569 5.30743 3.38492C6.04432 3.27415 6.79703 3.34145 7.50258 3.5812C8.20813 3.82095 8.84601 4.22618 9.36286 4.76298C9.8797 5.29978 10.2605 5.95254 10.4734 6.66667H11.6667C12.3742 6.66695 13.0588 6.91725 13.5996 7.37336C14.1404 7.82947 14.5026 8.46204 14.6223 9.15932C14.7419 9.85661 14.6113 10.5737 14.2534 11.184C13.8956 11.7943 13.3336 12.2586 12.6667 12.4947"
                stroke={color}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
